export class NotifyManagerErrors {
    static ENV_PARAMETER_NOT_SET = `Не указан параметр переменной среды, ответственный за данный запрос, обратитесь к разработчику`;
    static AUTH_ERROR = `Ошибка авторизации`;
    static FILE_SIZE_NO_LESS = `Размер файла не менее`;
    static FILE_SIZE_NO_MORE = `Размер файла не более`;
    static INCORRECT_UPLOAD_FORMAT = `Формат файла не доступен для загрузки`;
}